/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect, FC} from 'react'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../../_metronic/layout/core'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import {Form, Row} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import MasterServices from '../../../../../services/master'
import useServices from '../../../../../utils/hooks/useServices'
import JobServices from '../../../../../services/job'
import {toast} from 'react-toastify'

const CreateJobPage: FC = () => {
  let navigate = useNavigate()
  const [count, setCount] = useState(1)
  const [loading, setLoading] = useState(false)
  const [workingTypes, loadingWT, makeWtEmpty, triggerRefreshWt] = useServices(
    MasterServices.getWorkingType,
    {is_active: 1},
    []
  )
  const [jobLevels, loadingJL, makeJlEmpty, triggerRefreshJl] = useServices(
    MasterServices.getJobLevel,
    {is_active: 1},
    []
  )

  const [degrees, loadingDG, makeDGEmpty, triggerRefreshDG] = useServices(
    MasterServices.getDegree,
    null,
    []
  )

  const [skills, loadingSK] = useServices(MasterServices.getSkill, {is_active: 1}, [])
  const [languages, loadingLang] = useServices(MasterServices.getLanguage, {is_active: 1}, [])

  const [inputs, setInputs] = useState([
    {
      name: 'title',
      label: 'Posisi*',
      type: '',
      validation: {},
      mb: 'mb-8',
      col: 12,
      options: null,
      additional: '',
    },
    {
      name: 'working_types',
      label: 'Jenis Pekerjaan*',
      type: 'select',
      validation: {},
      mb: 'mb-8',
      col: 4,
      options: null,
      additional: '',
      getItemValue: 'working_types_name',
      getItemValueId: 'working_types_name',
    },
    {
      name: 'years_of_experience',
      label: 'Pengalaman Kerja (Tahun)*',
      type: 'number',
      validation: {},
      mb: 'mb-8',
      col: 4,
      options: null,
      additional: '',
      style: {
        marginTop: '-2.3%',
        right: '33%',
      },
    },
    {
      name: 'is_remote',
      label: 'Dapat dikerjakan remote?*',
      type: 'radio',
      validation: {},
      mb: 'mb-8',
      col: 4,
      options: [
        {
          name: 'Ya',
          value: '1',
        },
        {
          name: 'Tidak',
          value: '0',
        },
      ],
      additional: '',
      getItemValue: 'name',
      getItemValueId: 'value',
    },
    {
      name: 'degrees',
      label: 'Jenjang Pendidikan*',
      type: 'select',
      validation: {},
      mb: 'mb-8',
      col: 4,
      options: [],
      additional: '',
      getItemValue: 'degrees_name',
      getItemValueId: 'degrees_id',
    },
    {
      name: 'job_levels',
      label: 'Job Level',
      type: 'select',
      validation: {},
      mb: 'mb-8',
      col: 4,
      options: [],
      additional: '',
      getItemValue: 'job_levels_name',
      getItemValueId: 'job_levels_name',
    },
    {
      name: 'salary',
      label: 'Gaji',
      type: 'select2',
      validation: {},
      mb: 'mb-8',
      col: 4,
      options: [
        {
          name: 'Rp 4.000.000 - Rp 6.000.000',
          value: 'Rp 4.000.000 - Rp 6.000.000',
        },
        {
          name: 'Rp 7.000.000 - Rp 10.000.000',
          value: 'Rp 7.000.000 - Rp 10.000.000',
        },
        {
          name: 'Rp 10.000.000 - Rp 15.000.000',
          value: 'Rp 10.000.000 - Rp 15.000.000',
        },
        {
          name: 'Rp 15.000.000 - Rp 25.000.000',
          value: 'Rp 15.000.000 - Rp 25.000.000',
        },
        {
          name: 'Rp 25.000.000 - Rp 30.000.000',
          value: 'Rp 25.000.000 - Rp 30.000.000',
        },
        {
          name: 'Rp 30.000.000 - Rp 50.000.000',
          value: 'Rp 30.000.000 - Rp 50.000.000',
        },
        {
          name: 'Rp 50.000.000 - Rp 70.000.000',
          value: 'Rp 50.000.000 - Rp 70.000.000',
        },
        {
          name: '> Rp 70.000.000',
          value: '> Rp 70.000.000',
        },
      ],
      additional: '',
      getItemValue: 'name',
      getItemValueId: 'value',
    },
    // {
    //   name: 'working_time_start',
    //   label: 'Jam Kerja Awal',
    //   type: 'time',
    //   validation: {},
    //   mb: 'mb-8',
    //   col: 2,
    //   options: null,
    //   additional: '',
    // },
    // {
    //   name: 'working_time_end',
    //   label: 'Jam Kerja Akhir',
    //   type: 'time',
    //   validation: {},
    //   mb: 'mb-8',
    //   col: 2,
    //   options: null,
    //   additional: '',
    // },
    {
      name: 'max_age',
      label: 'Umur Maksimal (Tahun)*',
      type: 'number',
      validation: {},
      mb: 'mb-8',
      col: 4,
      options: null,
      additional: '',
    },
    {
      name: 'expired_date',
      label: 'Tanggal Akhir Lowongan*',
      type: 'date',
      validation: {},
      mb: 'mb-8',
      col: 4,
      options: null,
      additional: '',
    },
    {
      name: 'skills',
      label: 'Keahlian*',
      isMulti: true,
      type: 'select-creatable',
      validation: {},
      mb: 'mb-8',
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'skills_name',
      getItemValueId: 'skills_id',
    },
    {
      name: 'languages',
      label: 'Bahasa yang dikuasai*',
      isMulti: true,
      type: 'select-creatable',
      validation: {},
      mb: 'mb-8',
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'languages_name',
      getItemValueId: 'languages_id',
    },
    {
      name: 'description',
      label: 'Deskripsi Pekerjaan*',
      type: 'rich-text',
      validation: {},
      mb: 'mb-8',
      col: 12,
      options: null,
      additional: '',
    },
    {
      name: 'qualification',
      label: 'Kualifikasi*',
      type: 'rich-text',
      validation: {},
      mb: 'mb-8',
      col: 12,
      options: null,
      additional: '',
    },
    {
      name: 'benefit',
      label: 'Benefit*',
      type: 'rich-text',
      validation: {},
      mb: 'mb-8',
      col: 12,
      options: null,
      additional: '',
    },
  ])
  const [formValue, setFormValue] = useState({
    title: '',
    job_levels: '',
    seniority_levels: '',
    degrees: '',
    working_types: '',
    working_time_start: '',
    working_time_end: '',
    min_salary: '',
    max_salary: '',
    years_of_experience: '',
    is_remote: '',
    max_age: '',
    description: '',
    skills: [],
    languages: [],
  })

  useEffect(() => {
    let clone = inputs
    if (workingTypes && !loadingWT) {
      clone[1].options = workingTypes?.data?.data
      setInputs(clone)
      setCount((val) => val + 1)
      return
    }
  }, [workingTypes, loadingWT])

  useEffect(() => {
    let clone = inputs
    if (jobLevels && !loadingJL) {
      clone[5].options = jobLevels?.data?.data
      setInputs(clone)
      setCount((val) => val + 1)

      return
    }
  }, [jobLevels, loadingJL])

  useEffect(() => {
    let clone = inputs
    if (degrees && !loadingDG) {
      clone[4].options = degrees?.data?.data
      setInputs(clone)
      setCount((val) => val + 1)

      return
    }
  }, [degrees, loadingDG])

  useEffect(() => {
    let clone = inputs
    if (skills && !loadingSK) {
      clone[11].options = skills?.data?.data

      setInputs(clone)
      setCount((val) => val + 1)

      return
    }
  }, [skills, loadingSK])

  useEffect(() => {
    let clone = inputs
    if (languages && !loadingLang) {
      clone[12].options = languages?.data?.data
      setInputs(clone)
      setCount((val) => val + 1)

      return
    }
  }, [languages, loadingLang])

  const handleChange = (e: any) => {
    const {name, value} = e.target

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const getLanguage = async (q: any) => {
    try {
      setLoading(true)
      const {data} = await MasterServices.getLanguage({...{is_active: 1}, q})
      let clone = inputs
      clone[12].options = data.data
      setInputs(clone)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const getSkill = async (q: any) => {
    try {
      setLoading(true)
      const {data} = await MasterServices.getSkill({...{is_active: 1}, q})
      let clone = inputs
      clone[11].options = data.data
      setInputs(clone)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const onSelect = (input: any, row: any, key: any) => {
    const name = input
    switch (name) {
      case 'languages':
        getLanguage(row)
        break
      case 'skills':
        getSkill(row)
        break
    }
  }

  const handleSubmit = async (e: any) => {
    try {
      e?.preventDefault()
      setLoading(true)
      const formData = new FormData(e.target)

      let formProps = Object.fromEntries(formData)
      let salary: any = [null, null]
      if (formProps.salary) {
        salary = formProps.salary
          ?.toString()
          ?.split('Rp')
          ?.join()
          ?.split(' ')
          ?.join()
          ?.replaceAll(',', '')
          ?.replaceAll('.', '')
          ?.replaceAll('>', '')
          ?.split('-')
      }
      const languages = formValue?.languages?.map((v: any) => v.value)
      const skills = formValue?.skills?.map((v: any) => v.value)
      const degrees = parseInt(formValue?.degrees)

      await JobServices.createOrUpdate({
        ...formProps,
        min_salary: salary[0],
        max_salary: salary[1],
        languages,
        skills,
        degrees,
        seniority_levels: 'Senior',
      })
      navigate('/list-job')
      toast.success('Lowongan Pekerjaan Berhasil Dibuat')
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className='card-custom'>
        <PageTitle
          breadcrumbs={[
            {
              title: 'Dashboard',
              path: '/dashboard',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '/',
              path: '',
              isSeparator: false,
              isActive: false,
            },
          ]}
        >
          Buka Lowongan
        </PageTitle>
        <Form onSubmit={handleSubmit}>
          <Row>{count && FormGenerator(inputs, formValue, handleChange, onSelect, loading)}</Row>
          <Button
            style={{background: '#F5F8FA', color: '#333'}}
            onClick={() => navigate('/list-job')}
            type='button'
            disabled={loading}
          >
            Batalkan
          </Button>
          {'   '}
          <Button type='submit' disabled={loading}>
            Simpan
          </Button>
        </Form>
      </div>
    </>
  )
}

const CreateJob: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Buka Lowongan</PageTitle>
      <CreateJobPage />
    </>
  )
}

export default CreateJob
